import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';
import dayjs from 'dayjs';

const SEC = 1000;
const MIN = 60 * SEC;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;
const MONTH = 30 * DAY;

export function dayjsAgo(t: number): string {
  t = Date.now() - t * 1000;
  return dayjs(t).fromNow();
}

/**
 * @param t time in seconds
 */
export function ago(t: number): string {
  if (t < 0) {
    return '';
  }
  const distance = t * 1000;
  const months = Math.floor(distance / MONTH);
  const days = Math.floor((distance % MONTH) / DAY);
  const hours = Math.floor((distance % DAY) / HOUR);
  const minutes = Math.floor((distance % HOUR) / MIN);
  const seconds = Math.floor((distance % MIN) / SEC);
  const ret: string[] = [];
  if (months > 0) {
    ret.push(`${months}M`);
  }
  if (days > 0) {
    ret.push(`${days}d`);
  }
  if (months > 0) {
    return ret.join(' ');
  }
  if (hours > 0) {
    ret.push(`${hours}h`);
  }
  if (days > 0) {
    return ret.join(' ');
  }
  if (minutes > 0) {
    ret.push(`${minutes}m`);
  }
  if (hours > 0) {
    return ret.join(' ');
  }
  ret.push(`${seconds}s`);

  return ret.join(' ');
}

export const fadeSlowAnimation = trigger('fadeSlow', [
  state('*', style({ opacity: 1 })),
  state('void', style({ opacity: 0 })),
  transition('* <=> *', [animate(`250ms ease-in-out`)])
]);

export const slideInAnimation = trigger('slideIn', [
  state('*', style({ transform: 'translate3d(0, 0, 0)' })),
  state(
    'void',
    style({ transform: 'translate3d(-100%, 0, 0)', visibility: 'visible' })
  ),
  transition('void => *', [animate(`500ms ease-in-out`)])
]);

export const slideOutAnimation = trigger('slideOut', [
  state('*', style({ transform: 'translate3d(0, 0, 0)' })),
  state(
    'void',
    style({ transform: 'translate3d(100%, 0, 0)', visibility: 'hidden' })
  ),
  transition('* => void', [animate(`500ms ease-in-out`)])
]);
